import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { DesignerRoute } from "./designer/DesignerRoute";
import { ErrorPage } from "./pages/ErrorPage";
import { ExportDesignRoute } from "./pages/export/ExportDesignRoute";
import { RootRoute } from "./RootRoute";

import "./App.sass";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <RootRoute />,
      errorElement: <ErrorPage />,
      children: [
        {
          path: "/",
          element: <DesignerRoute />,
        },
        {
          path: "export",
          element: <ExportDesignRoute />,
        },
      ],
    },
  ],
  {
    basename: import.meta.env.VITE_BASE_URL,
  },
);

export const App: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
};
